import Animation from "../classes/Animation";

import each from 'lodash/each';
import gsap from 'gsap';

import { calculate, split } from '../utils/text';

export default class Paragraph extends Animation {
    constructor({ element, elements }){
        super({
            element,
            elements
        })

        this.animated = false

        this.elementLinesSpans = split({ element: this.element, append: true });
    }

    animateIn(){
        this.timelineIn = gsap.timeline({
            delay: .5, 
        });

        if(!this.animated){
            this.timelineIn.set(this.element, {
                autoAlpha: 1
            })

            each(this.elementLines, (line, index) =>{
                this.timelineIn.fromTo(line, {
                    autoAlpha: 0,
                    y: '100%',
                },{
                    autoAlpha: 1,
                    delay: index * 0.005,
                    duration: 1.5,
                    ease: 'expo.out',
                    y: 0
                }, 0)
            })
        }

        this.animated = this.element.hasAttribute('data-animation-once') ? true : false
    }

    animateOut(){
        if(!this.animated){
            gsap.set(this.element, {
                autoAlpha: 0
            })
        }
    }

    onResize() {
        this.elementLines = calculate(this.elementLinesSpans)
    }
}